<template>
  <div>
    <div style="text-align: left;padding-left: 10px">
      <el-button round @click="back()"
                 size="middle">返回
      </el-button>
    </div>

    <div style=" width:1380px;margin: 50px auto; background: #F8F8FB;padding: 50px">
        <span style="font-size: 18px;font-weight: bold;margin: 0 25px 25px;display: inline-block;">
          <i class="el-icon-user-solid"></i>
          导师信息</span>
      <el-form label-width="100px" style="margin-left: 0px" size="mini">
        <el-form-item label="导师信息:">
          <el-table :data="teacherData" :header-cell-style="getHeaderStyle" size="mini" border style="width: 98.4%;">
            <el-table-column type="index" width="40"></el-table-column>
            <el-table-column prop="teacherName" show-tooltip-when-overflow label="姓名" width="90"></el-table-column>
            <el-table-column prop="teacherIdCardNo"  label="身份证号" width="200"></el-table-column>
            <el-table-column prop="teacherEmail" show-tooltip-when-overflow label="邮箱" width="200"></el-table-column>
            <el-table-column prop="teacherSchoolName" show-tooltip-when-overflow label="学校"
                             width="180"></el-table-column>
            <el-table-column prop="teacherCollege" show-tooltip-when-overflow label="学院"
                             width="180"></el-table-column>
            <el-table-column prop="teacherFieldName" show-tooltip-when-overflow label="专业"
                             width="150"></el-table-column>
            <el-table-column prop="teacherTitle" show-tooltip-when-overflow label="职称" width="170"></el-table-column>
            <el-table-column prop="operate" label="操作" width="150">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="editTeacher(scope.$index,scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="deleteTeacher(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div style="text-align: right;margin-right: 16px;">
        <el-button @click="addTeacher()" size="mini" icon="el-icon-plus">添加老师</el-button>
      </div>
      <span style="font-size: 18px;font-weight: bold;margin: 55px 25px 25px;display: inline-block;">
          <i class="el-icon-user-solid"></i>
          成员信息</span>
      <el-form :inline="true" :model="playerForm" :rules="memberRules" ref="ruleForm" label-width="100px" size="mini"
               class="demo-ruleForm" style="margin-left: 0;width: 100%">
        <el-form-item label="团队名称:" prop="teamName" style="width: 48%;display: inline-block">
          <el-input v-model="playerForm.teamName" style="width: 100%;min-width: 350px;"></el-input>
        </el-form-item>
        <el-form-item label="参赛栏目:" prop="gameItem" style="width: 48%;display: inline-block">
          <el-select v-model="playerForm.gameItem" placeholder="请选择" style="width: 100%;min-width: 350px;">
            <el-option
              v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="成员信息:">
          <el-table :data="memberData" :header-cell-style="getHeaderStyle" size="mini" border style="width: 100%">
            <el-table-column type="index" width="40"></el-table-column>
            <el-table-column prop="memberRole" width="60" label="角色"></el-table-column>
            <el-table-column prop="memberName" show-tooltip-when-overflow label="姓名" width="80"></el-table-column>
            <el-table-column prop="idCardNo" label="身份证号" width="150"></el-table-column>
            <el-table-column prop="phone" label="手机号" width="110"></el-table-column>
            <el-table-column prop="email" show-tooltip-when-overflow label="邮箱" width="120"></el-table-column>
            <el-table-column prop="schoolName" show-tooltip-when-overflow label="学校" width="110"></el-table-column>
            <el-table-column prop="college" show-tooltip-when-overflow label="学院" width="110"></el-table-column>
            <el-table-column prop="fieldName" show-tooltip-when-overflow label="专业" width="130"></el-table-column>
            <el-table-column prop="grade" show-tooltip-when-overflow label="年级" width="100"></el-table-column>
            <el-table-column prop="operate" label="操作" width="150">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="editMember(scope.$index,scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="deleteMember(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div style="text-align: right;margin-right: 16px;">
        <el-button @click="addMember()" size="mini" icon="el-icon-plus">添加队员</el-button>
      </div>
      <div style="text-align: center;margin-top: 30px">
        <el-button round style="width: 250px;" @click="updateTeamMessage()"
                   size="middle">确认修改
        </el-button>
      </div>
    </div>
    <!--添加成员-->
    <el-dialog :title="memberDialogTitle" v-if="memberDialog" :visible.sync="memberDialog" v-dialogDrag destroy-on-close
               :close-on-click-modal="false" append-to-body width="650px">

      <el-form :inline="true" label-width="90px" :rules="memberDialogRules" :model="memberDialogForm" size="mini"
               ref="memberDialogForm">
        <el-form-item label="角色:">
          <el-input v-model.trim="memberDialogForm.memberRole" :disabled="true" @input="change($event)"
                    style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="姓名:" prop="memberName">
          <el-input v-model.trim="memberDialogForm.memberName" placeholder="请输入姓名" @input="change($event)"
                    style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="身份证号:" prop="idCardNo">
          <el-input v-model.trim="memberDialogForm.idCardNo" placeholder="请输入身份证号" @input="change($event)"
                    style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="phone">
          <el-input v-model.trim="memberDialogForm.phone" placeholder="请输入手机号" @input="change($event)"
                    style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="邮箱:" prop="email">
          <el-input v-model.trim="memberDialogForm.email" placeholder="请输入邮箱" @input="change($event)"
                    style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="学校:" prop="schoolName">
          <el-input v-model.trim="memberDialogForm.schoolName" placeholder="请输入学校" @input="change($event)"
                    style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="学院:" prop="college">
          <el-input v-model.trim="memberDialogForm.college" placeholder="请输入学院" @input="change($event)"
                    style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="专业:" prop="fieldName">
          <el-input v-model.trim="memberDialogForm.fieldName" placeholder="请输入专业" @input="change($event)"
                    style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="年级:" prop="grade">
          <el-select v-model="memberDialogForm.grade" placeholder="请选择" style="width: 190px;">
            <el-option
              v-for="item in gradeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveMember('memberDialogForm')" size="mini">提 交</el-button>
        <el-button type="danger" @click="memberDialog = false" size="mini">关 闭</el-button>
      </div>
    </el-dialog>

    <!--添加老师-->
    <el-dialog :title="teacherDialogTitle" v-if="teacherDialog" :visible.sync="teacherDialog" v-dialogDrag
               destroy-on-close :close-on-click-modal="false"
               append-to-body width="650px">

      <el-form :inline="true" label-width="90px" :rules="teacherRules" :model="teacherForm" size="mini"
               ref="teacherForm">
        <el-form-item label="姓名:" prop="teacherName">
          <el-input v-model.trim="teacherForm.teacherName" placeholder="请输入姓名" @input="change($event)"
                    style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="身份证号:" prop="teacherIdCardNo">
          <el-input v-model.trim="teacherForm.teacherIdCardNo" placeholder="请输入身份证号" @input="change($event)"
                    style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="邮箱:" prop="teacherEmail">
          <el-input v-model.trim="teacherForm.teacherEmail" placeholder="请输入邮箱" @input="change($event)"
                    style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="学校:" prop="teacherSchoolName">
          <el-input v-model.trim="teacherForm.teacherSchoolName" placeholder="请输入学校" @input="change($event)"
                    style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="学院:" prop="teacherCollege">
          <el-input v-model.trim="teacherForm.teacherCollege" placeholder="请输入学院" @input="change($event)"
                    style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="专业:" prop="teacherFieldName">
          <el-input v-model.trim="teacherForm.teacherFieldName" placeholder="请输入专业" @input="change($event)"
                    style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="职称:" prop="teacherTitle">
          <el-input v-model.trim="teacherForm.teacherTitle" placeholder="请输入职称" @input="change($event)"
                    style="width: 190px;"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveTeacher('teacherForm')" size="mini">提 交</el-button>
        <el-button type="danger" @click="teacherDialog = false" size="mini">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {promptData, successPromptData} from "../../util/MessageTools";
  import {
    gameItemEnumToString,
    getGameItemOption,
    gradeEnumToString,
    gradeStringToEnum
  } from "../../util/EnumTransition";
  import api from "../../api";
  import router from "../../router";

  export default {
        name: "teamMessage",
      data(){
          return {
            userId: null,
            options: [],//参赛栏目的数组
            gradeOptions: [{
              value: "UNDERGRADE",
              label: "本科生",
            }, {
              value: "MASTER",
              label: "硕士研究生",
            }, {
              value: "DOCTOR",
              label: "博士研究生",
            }],
            value: '',
            teacherForm: {//老师信息
              teacherName: "",
              teacherIdCardNo: "",//身份证号
              teacherSchoolName: "",//学校
              teacherCollege: "",//学院
              teacherFieldName: "",//专业
              teacherEmail: "",//邮箱
              teacherTitle: "",//职称
            },
            teacherData: [],//导师的信息
            memberData: [],//成员信息
            playerForm: {//团队成员信息
              teamName: "",
              gameItem: "RES_CITY_SUS_URBAN_DEV",
            },
            memberDialogForm: {//添加成员的dialog
              memberRole: "成员",
              memberName: "",
              idCardNo: "",
              phone: "",
              email: "",
              schoolName: "",
              college: "",
              grade: "",
              fieldName: "",
            },
            teacherRules: {
              teacherName: [
                {required: true, message: '请输入姓名', trigger: 'submit'},
                {min: 1, max: 10, message: '姓名不能超过10个文字', trigger: 'submit'},
              ],
              teacherIdCardNo:[
                {required: true, message: '请输入身份证号', trigger: 'submit'},
                {min: 18, max: 18, message: '您输入的身份证号有误', trigger: 'submit'},
                {
                  pattern:
                    /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                  message: '您输入的身份证号码有误',
                  trigger: 'submit'
                },
              ],
              teacherSchoolName: [
                {required: true, message: '请输入学校', trigger: 'submit'},
                {min: 1, max: 20, message: '学院不能超过20个文字', trigger: 'submit'},
              ],
              teacherCollege: [
                {required: true, message: '请输入学院', trigger: 'submit'},
                {min: 1, max: 20, message: '学院不能超过20个文字', trigger: 'submit'},
              ],
              teacherFieldName: [
                {required: true, message: '请输入专业', trigger: 'submit'},
                {min: 1, max: 20, message: '专业不能超过20个文字', trigger: 'submit'},
              ],
              teacherEmail: [
                {required: true, message: '请输入邮箱', trigger: 'submit'},
                // {
                //   pattern:
                //     /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
                //   message: '您输入的邮箱有误,请检查', trigger: 'submit'
                // },
              ],
              teacherTitle: [
                {required: true, message: '请输入职称', trigger: 'submit'},
                {min: 1, max: 10, message: '职称不能超过10个文字', trigger: 'submit'},
              ],
            },
            memberRules: {
              teamName: [
                {required: true, message: '请输入团队名称', trigger: 'submit'},
                {min: 1, max: 20, message: '团队名称不能超过20个文字', trigger: 'submit'},
              ],
            },
            memberDialogRules: {
              memberName: [
                {required: true, message: '请输入姓名', trigger: 'submit'},
                {min: 1, max: 10, message: '姓名不能超过10个文字', trigger: 'submit'},
              ],
              idCardNo: [
                {required: true, message: '请输入身份证号', trigger: 'submit'},
                {min: 18, max: 18, message: '您输入的身份证号有误', trigger: 'submit'},
                {
                  pattern:
                    /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                  message: '您输入的身份证号码有误',
                  trigger: 'submit'
                },
              ],
              phone: [
                {required: true, message: '请输入手机号码', trigger: 'submit'},
                {min: 11, max: 11, message: '您输入的手机号有误', trigger: 'submit'},
                /* {pattern: /^1[3|4|5|8][0-9]\d{4,8}$/, message: '您输入的手机号有误', trigger: 'submit'},*/
              ],
              email: [
                {required: true, message: '请输入邮箱', trigger: 'submit'},
                // {
                //   pattern:
                //     /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
                //   message: '您输入的邮箱有误,请检查', trigger: 'submit'
                // },
              ],
              schoolName: [
                {required: true, message: '请输入学校', trigger: 'submit'},
                {min: 1, max: 20, message: '学校不能超过20个文字', trigger: 'submit'},
              ],
              college: [
                {required: true, message: '请输入学院', trigger: 'submit'},
                {min: 1, max: 20, message: '学院不能超过20个文字', trigger: 'submit'},
              ],
              grade: [
                {required: true, message: '请输入年级', trigger: 'submit'},
                {min: 1, max: 20, message: '年级不能超过20个文字', trigger: 'submit'},
              ],
              fieldName: [
                {required: true, message: '请输入专业', trigger: 'submit'},
                {min: 1, max: 20, message: '专业不能超过20个文字', trigger: 'submit'},
              ]
            },
            teacherDialogTitle: "",//导师弹出框的title
            teacherDialog: "",//添加导师的弹出框
            teacherFlag: 1,//导师添加或者修改 1代表添加  2代表修改
            teacherEditRowIndex: '',//导师table编辑行的下标

            memberDialogTitle: "",//成员弹出框的title
            memberDialog: false,//添加成员的弹出框
            memberFlag: 1,//成员添加或者修改 1代表添加  2代表修改
            memberEditRowIndex: '',//成员table编辑行的下标
          }
      },
      methods:{
        /**
         * 返回团队报名审核
         */
        back(){
          this.$router.push('/admin/enter_for_check')
        },
        /**
         * 确认修改
         */
        updateTeamMessage(){
          let vue = this

          let memberData = $.extend(true, [], this.memberData)//深拷贝

          for (let p = 0; p < memberData.length; p++) {
            memberData[p].grade = gradeStringToEnum(memberData[p].grade)
          }
          let captain = memberData[0]
          memberData.splice(0, 1)
          if (this.teacherData.length === 0) {
            promptData("请填写导师信息!", this)
            return;
          }
          let certificateInfo = {}
          certificateInfo.userId = this.userId
          if (captain.memberName === undefined || captain.memberName.trim() === "" || captain.memberName == null) {
            promptData("队长姓名不能为空!", this)
            return
          }
          if (this.playerForm.teamName === undefined || this.playerForm.teamName.trim() === "" || this.playerForm.teamName == null) {
            promptData("团队名称不能为空!", this)
            return
          }
          certificateInfo.teamName = this.playerForm.teamName
          certificateInfo.gameItem = this.playerForm.gameItem

          certificateInfo.uploadTime = new Date()

          certificateInfo.leaderName = captain.memberName//队长信息
          certificateInfo.leaderIdCardNo = captain.idCardNo
          certificateInfo.leaderPhone = captain.phone
          certificateInfo.leaderEmail = captain.email
          certificateInfo.leaderSchoolName = captain.schoolName
          certificateInfo.leaderCollege = captain.college
          certificateInfo.leaderGrade = captain.grade
          certificateInfo.leaderFieldName = captain.fieldName

          certificateInfo.memberInfos = memberData   //成员信息

          certificateInfo.teacherInfos = this.teacherData

          //查找身份证号是否有一样的
          let cardIds = []
          for (let k = 0; k < memberData.length; k++) {
            cardIds.push(memberData[k].idCardNo)
          }

          for (let p = 0; p < cardIds.length - 1; p++) {
            if (cardIds[p] === cardIds[p + 1]) {
              promptData("成员身份证不能相同!", this)
              return;
            }
          }

          api.enterFor.updateCertificateInfoByUserId(certificateInfo).then(function (response) {
            if (response == null) {
              return
            }
            if (response.data.code === '0') {
              successPromptData("修改信息成功!", vue)
            }
          })


        },
        /**
         * table 的表头样式
         * @param rowIndex
         * @returns {string}
         */
        getHeaderStyle({rowIndex}) {
          if (rowIndex === 0) {
            return 'background:#405AA7;color: #fff'
          } else {
            return ''
          }
        },

        //更新input框的数据
        change(e) {
          this.$forceUpdate()//(固定语法)
        },

        /**
         * 添加成员
         */
        addMember() {
          if (this.memberData.length >= 6) {
            promptData("最多填写六名成员!", this)
            return
          }
          this.memberDialogForm = {}
          this.memberDialogTitle = "添加成员信息"
          this.memberFlag = 1//1代表添加  2代表修改
          this.memberDialogForm.memberRole = "成员"
          this.memberDialog = true
        },

        /**
         * 编辑成员
         * @param row 行信息
         */
        editMember(index, row) {
          this.memberEditRowIndex = index
          this.memberDialogTitle = "编辑成员信息"
          this.memberFlag = 2//1代表添加  2代表修改
          this.memberDialogForm.memberRole = row.memberRole
          this.memberDialogForm.memberName = row.memberName
          this.memberDialogForm.idCardNo = row.idCardNo
          this.memberDialogForm.phone = row.phone
          this.memberDialogForm.email = row.email
          this.memberDialogForm.schoolName = row.schoolName
          this.memberDialogForm.college = row.college
          this.memberDialogForm.grade = gradeStringToEnum(row.grade)
          this.memberDialogForm.fieldName = row.fieldName
          this.memberDialog = true
        },

        /**
         * 删除一个成员信息
         * @param index 下标
         * @param row 删除行
         */
        deleteMember(index, row) {
          if (row.memberRole === "队长") {
            promptData("队长信息不允许删除!", this)
            return
          }
          this.memberData.splice(index, 1)
        },

        /**
         * 保存添加成员的信息
         * @param formName 表单名称
         */
        saveMember(formName) {
          let vue = this
          this.$refs[formName].validate((valid) => {
              if (valid) {
                let obj = {}
                obj.memberRole = vue.memberDialogForm.memberRole
                obj.memberName = vue.memberDialogForm.memberName
                obj.idCardNo = vue.memberDialogForm.idCardNo
                obj.phone = vue.memberDialogForm.phone
                obj.email = vue.memberDialogForm.email
                obj.schoolName = vue.memberDialogForm.schoolName
                obj.college = vue.memberDialogForm.college
                obj.grade = gradeEnumToString(vue.memberDialogForm.grade)
                obj.fieldName = vue.memberDialogForm.fieldName
                if (vue.memberFlag === 1) {//添加
                  vue.memberData.push(obj)
                } else {
                  vue.memberData[vue.memberEditRowIndex] = obj
                  vue.memberData = JSON.parse(JSON.stringify(vue.memberData))//不知道赋值为什么赋不进去
                }
                vue.memberDialog = false
              }
            }
          );
        },

        /**
         * 添加老师
         */
        addTeacher() {
          if (this.teacherData.length >= 2) {
            promptData("最多填写两名老师!", this)
            return
          }
          this.teacherForm = {}
          this.teacherDialogTitle = "添加导师信息"
          this.teacherFlag = 1//1代表添加  2代表修改
          this.teacherDialog = true
        },

        /**
         * 编辑导师所选信息
         * @param index
         * @param row
         */
        editTeacher(index, row) {
          this.teacherEditRowIndex = index
          this.teacherDialogTitle = "编辑导师信息"
          this.teacherFlag = 2//1代表添加  2代表修改
          this.teacherDialog = true
          this.teacherForm.teacherName = row.teacherName
          this.teacherForm.teacherIdCardNo =  row.teacherIdCardNo
          this.teacherForm.teacherEmail = row.teacherEmail
          this.teacherForm.teacherSchoolName = row.teacherSchoolName
          this.teacherForm.teacherCollege = row.teacherCollege
          this.teacherForm.teacherFieldName = row.teacherFieldName
          this.teacherForm.teacherTitle = row.teacherTitle
        },

        /**
         * 删除一个成员信息
         * @param index 下标
         * @param row 删除行
         */
        deleteTeacher(index, row) {
          this.teacherData.splice(index, 1)
        },

        /**
         * 保存老师
         * @param formName 表单
         */
        saveTeacher(formName) {
          let vue = this
          this.$refs[formName].validate((valid) => {
              if (valid) {
                let obj = {}
                obj.teacherName = vue.teacherForm.teacherName
                obj.teacherIdCardNo =  vue.teacherForm.teacherIdCardNo

                obj.teacherEmail = vue.teacherForm.teacherEmail
                obj.teacherSchoolName = vue.teacherForm.teacherSchoolName
                obj.teacherCollege = vue.teacherForm.teacherCollege
                obj.teacherFieldName = vue.teacherForm.teacherFieldName
                obj.teacherTitle = vue.teacherForm.teacherTitle
                if (vue.teacherFlag === 1) {//添加
                  vue.teacherData.push(obj)
                } else {
                  vue.teacherData[vue.teacherEditRowIndex] = obj
                  vue.teacherData = JSON.parse(JSON.stringify(vue.teacherData))//不知道赋值为什么赋不进去
                }
                vue.teacherDialog = false
              }
            }
          );
        },
      },
      mounted() {
          if(this.$route.params.userId) {
            this.userId = this.$route.params.userId
            let vue = this
            vue.options = getGameItemOption()
            api.enterFor.getCertificateInfoByUserId(this.$route.params.userId).then(function (response) {
              if (response.data.code === '0') {
                let result = response.data.result
                vue.playerForm.teamName = result.teamName
                vue.playerForm.gameItem = result.gameItem
                vue.memberData = []
                let obj = {}
                obj.memberRole = '队长'
                obj.memberName = result.leaderName //队长信息
                obj.idCardNo = result.leaderIdCardNo
                obj.phone = result.leaderPhone
                obj.email = result.leaderEmail
                obj.schoolName = result.leaderSchoolName
                obj.college = result.leaderCollege
                obj.grade = gradeEnumToString(result.leaderGrade)
                obj.fieldName = result.leaderFieldName
                vue.memberData.push(obj)
                if (result.memberInfos != null) {
                  for (let i = 0; i < result.memberInfos.length; i++) {
                    result.memberInfos[i].memberRole = '队员'
                    result.memberInfos[i].grade = gradeEnumToString(result.memberInfos[i].grade)
                    vue.memberData.push(result.memberInfos[i])
                  }
                }
                vue.certificateReason = result.certificateReason
                vue.teacherData = result.teacherInfos
              }
            })
          } else {
            this.$router.push('/admin/enter_for_check')
          }
      },
      created() {


      }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/Admin/teamMessage.vue